<div class="flex-auto flex items-center container justify-between">
  <div class="font-medium">
    © 2024 +Credimás. Todos los derechos reservados.
  </div>
  <div class="text-secondary text-sm">
    Puntomas v7 — Sistema de Gestión de Reparación de Crédito
  </div>
</div>
